import React from 'react';
import { apiService } from '../services/apiService';
import { DSButton } from '../design-system/primitives';
import { usePhotoUpload } from '../hooks/usePhotoUpload';
import { eventImage } from './EventsBrowse';
import './EventPhotoControl.css';

/**
 * An event's photo with upload, replace and remove, for the edit form.
 *
 * Saves on its own as soon as a photo is picked, not with the form's Save button,
 * the same as profile photos. The preview is whatever the event currently shows,
 * so an event in a series previews the series image until it has a photo of its
 * own. `onChange` gets the new photo_url (or null) so the page can refetch.
 */
function EventPhotoControl({ event, onChange }) {
  const photo = usePhotoUpload({
    upload: (file) => apiService.uploadEventPhoto(event.id, file),
    remove: () => apiService.deleteEventPhoto(event.id),
    onChange,
    fileName: 'event.jpg'
  });

  const hasOwnPhoto = Boolean(event.photo_url);
  const preview = eventImage(event);

  return (
    <div className="event-photo">
      <div className="event-photo__frame">
        {preview
          ? <img className="event-photo__img" src={preview} alt="" />
          : <span className="event-photo__empty">No photo</span>}
      </div>
      <p className="event-photo__hint">
        {hasOwnPhoto || !preview
          ? 'Shown on the event page, the club TVs and shared links. Saves as soon as you pick one.'
          : 'Using the series image. Upload one to give this date its own. Saves as soon as you pick one.'}
      </p>
      <div className="event-photo__actions">
        <DSButton appearance="outline" tone="neutral" size="sm" disabled={photo.busy} onClick={photo.pick}>
          {hasOwnPhoto ? 'Replace photo' : 'Upload photo'}
        </DSButton>
        {hasOwnPhoto && (
          <DSButton appearance="text" tone="neutral" size="sm" disabled={photo.busy} onClick={photo.remove}>
            Remove
          </DSButton>
        )}
      </div>
      <input {...photo.inputProps} />
    </div>
  );
}

export default EventPhotoControl;
